// all kinds of minor initialisations done on DOMContentLoaded

$(document).ready(function(){
  $('.featured-product-image-wrapper').mouseout(function(){
    var mainimg = $(this).children().children("img.pimagemain").attr("data-src");
    $(this).children().children("img.pimagemain").attr("src",mainimg);
  });

  // lazySizes initialisation
  window.lazySizesConfig = window.lazySizesConfig || {};
  window.lazySizesConfig.preloadAfterLoad = true;
  window.lazySizesConfig.expand = 700;

  // initialise lightboxes
  setupLightBox(".lightbox-image");

  // show product images after 2 seconds
  setTimeout(function(){
    // $(".slick-arrow").text(" ").css('color', 'white');
     $('.image-slider').removeClass("hide");
  }, 2000);

  // init "links" that open plastic counter
  for (const el of document.querySelectorAll('.open-plastic-counter')) {
    el.addEventListener('click', () => {
      document.querySelector('.header-plastic-counter__heading').click();
    })
  }
});